import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation } from "react-router-dom";
import Login from "./components/Login";
// import UploadTab from "./components/UploadTab";
// import LiveCall from "./components/LiveCall";
import SurveyResults from "./components/SurveyResults";
import Dashboard from "./components/Dashboard";
import Corrections from "./components/Corrections";
// import Settings from "./components/Settings";


const TopBar: React.FC = () => {
  const location = useLocation();
  const tabNames: { [key: string]: string } = {
    // "/upload": "Call List",
    // "/call": "Live Call",
    "/results": "Survey Results",
    "/dashboard": "Dashboard",
    "/corrections": "Corrections",
    // "/settings": "Settings",
  };
  const current = tabNames[location.pathname] || "Welcome Agent";

  const handleLogout = () => {
    localStorage.removeItem("auth");
    window.location.reload();
  };

  return (
    <div className="w-full bg-[#001d3d] text-white flex justify-between items-center px-6 py-2">
      <h2 className="text-lg font-semibold">{current}</h2>
      <button
        onClick={handleLogout}
        className="text-xs border border-white px-2 py-1 rounded hover:opacity-90"
      >
        Logout
      </button>
    </div>
  );
};

function App() {
  const isAuthenticated = localStorage.getItem("auth") === "true";

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <div className="flex h-screen w-screen overflow-hidden font-sans">
        {/* Sidebar */}
        <aside className="w-44 bg-[#001d3d] text-white flex flex-col px-4 py-6">
          {/* Logo */}
          <div className="flex flex-col items-center mb-6">
            <img
              src="https://plan.totogi.com/assets/img/totogi-logo-white.svg"
              alt="Totogi Logo"
              className="h-8 w-auto mb-2"
            />
            <h1 className="text-base font-medium">Outbound Agent</h1>
          </div>



          <nav className="space-y-3">
            {/* <Link to="/upload" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Call List</Link>
            <Link to="/call" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Live Call</Link> */}
            <Link to="/results" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Survey Results</Link>
            <Link to="/dashboard" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Dashboard</Link>
            <Link to="/corrections" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Corrections</Link>
            {/* <Link to="/settings" className="block bg-[#001d3d] border border-[#001d3d] px-4 py-2 rounded hover:bg-[#133153]">Settings</Link> */}

          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1 min-w-0 bg-gray-100 flex flex-col">
          <TopBar />
          <div className="flex-1 overflow-auto p-6">
            <Routes>
              {/* <Route path="/upload" element={<UploadTab />} />
              <Route path="/call" element={<LiveCall />} /> */}
              <Route path="/results" element={<SurveyResults />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/corrections" element={<Corrections />} />
              {/* <Route path="/settings" element={<Settings />} /> */}

              {/* Default redirect */}
              <Route path="*" element={<Navigate to="/results" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
